import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Page, ROOT_NAVIGATION, disableByPermissions, disableByLogisticsPermissions } from 'src/app/config/navigation.config';
import { ExtranetModule } from '../modules-access/extranet-module.enum';
import { ModuleAccessService } from '../modules-access/module-access.service';
import { Quart, TweenMax } from 'gsap/all';
import { DialogService } from '../confirm-dialog/dialog.service';
import { environment } from '../../../environments/environment';
import { CutParamsFromUrl, RedirectToChangePassword } from '../../config/utils.config';
import { HttpClient } from '@angular/common/http';
import { ShipmentApiVersion } from './shipment.model';
import { rejectedIdsKey } from './notification-bar/notification-bar.model';
import packageJson from '../../../../package.json';
import { ShipmentApiUrlService } from 'src/app/services/shipment-api-url.service';

declare var require: any;

const { version: appVersion } = require('../../../../package.json');

const allowedPackages = [
  "@kns-jasfbg/feature-shipment",
  "@jas-fbg-sa/feature-agencies",
  "@jas-fbg-sa/feature-settlements",
  "@jas-fbg-sa/feature-logistics",
  "@kns-jasfbg/users",
  "@kns-jasfbg/notifications",
  "@kns-jasfbg/kns-snackbar",
  ...(environment.enableFeatureHelp ? ["@jas-fbg-sa/feature-help"] : []),
  ...(environment.enableFeatureComplaints ? ["@kns-jasfbg/feature-complaints"] : [])
];

@Component({
    selector: 'app-core-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  public ExtranetModule = ExtranetModule;
  public sidebarToggled = false;
  public username: string;
  public rootNavigation: Page[] = ROOT_NAVIGATION;
  currentRoute: string;
  version = appVersion;
  navbarHeight = '65px';
  shipmentApiVersion: ShipmentApiVersion;
  maxNotificationsHeight = 0;
  environment = environment;

  redirectToChangePassword = RedirectToChangePassword;
  consentsNeedApprove: boolean;
  dependencies: Dependency[] = [];

  constructor(private serviceDialog: DialogService, public router: Router,
    public oauthService: OAuthService,
    private http: HttpClient,
    public shipmentApiUrlService: ShipmentApiUrlService,
    private moduleAccessService: ModuleAccessService) {

  }

  async ngOnInit(): Promise<void> {
    const claims = this.oauthService.getIdentityClaims();
    this.rootNavigation = await disableByPermissions(this.rootNavigation, claims['extranet_modules_shipmentservice_permissions']);
    this.rootNavigation = await disableByLogisticsPermissions(this.rootNavigation, claims['extranet_modules_logistics_permissions']);
    if (packageJson.dependencies) {
      this.dependencies = Object.entries(packageJson.dependencies).filter(([name]) => allowedPackages.includes(name)).map(([name, version]) => ({ name: name.split('/').pop() || name, version }));
    }
    if (this.moduleAccessService.currentUserHasAccessTo(ExtranetModule.Shipment)) {
      this.loadShipmentApiVersion();
    }
    this.spinButton();
  }

  public toggleShipmentApi(useAlternate: boolean): void {
    this.shipmentApiUrlService.setAlternateSelected(useAlternate);
    window.location.reload();
  }

  private loadShipmentApiVersion(): void {
    try {
      this.http.get<ShipmentApiVersion>(this.shipmentApiUrlService.getCurrentUrl() + 'appinfo').subscribe((data: ShipmentApiVersion) => {
        this.shipmentApiVersion = data;
      });
    } catch (e) {
      console.error(e);
    }
  }

  public toggleSidebar() {
    this.sidebarToggled = !this.sidebarToggled;
  }

  public navigate(path) {
    this.router.navigateByUrl(`/${path}`);
  }

  public navigateToSampleApplication() {
    this.router.navigateByUrl('/sample-application');
  }

  public hasAccessTo(module: ExtranetModule): boolean {
    return this.moduleAccessService.currentUserHasAccessTo(module);
  }

  public getTabsForCurrentPath(): Page {
    return this.rootNavigation.filter(el => el.pathPatterns.some(pattern => pattern.test(CutParamsFromUrl(this.router.url))))[0];
  }

  public logout() {
    sessionStorage.removeItem(rejectedIdsKey);
    this.oauthService.logOut();
  }

  openConfirmDialog() {
    this.serviceDialog.openConfirmDialog('doWantLogout').afterClosed().subscribe(res => {
      if (res) {
        this.logout();
      }
    });
  }

  public spinButton() {

    var toggle, icon;

    function onClickToggle() {
      toggle = $('#togglex');
      icon = $('#iconx');
      var aniEasing = Quart.easeInOut,
        duration = 0.70,
        top = icon.find('.top-icon'),
        bottom = icon.find('.bottom-icon');

      toggle.toggleClass('active');

      if (!toggle.hasClass('animation')) {
        toggle.addClass('animation');
        TweenMax.to(icon, duration, {
          rotation: '+=180',
          ease: aniEasing,
          onComplete: function () {
            toggle.removeClass('animation');
          }
        });

        if (toggle.hasClass('active')) {
          TweenMax.to(top, duration, {
            width: '50%',
            rotation: 45,
            x: '104%',
            y: 2,
            ease: aniEasing,
            yoyo: true
          });
          TweenMax.to(bottom, duration, {
            width: '50%',
            rotation: -45,
            x: '108%',
            y: -2,
            ease: aniEasing
          });
        } else {
          TweenMax.to(top, duration, {
            width: '100%',
            rotation: 0,
            x: '0%',
            y: 0,
            ease: aniEasing
          });
          TweenMax.to(bottom, duration, {
            width: '100%', rotation: 0,
            x: '0%',
            y: 0,
            ease: aniEasing
          });
        }
      }
    }

    $(onClickToggle);
  }
}

interface Dependency {
  name: string;
  version: string;
}
